var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameMyStatus = function SvgIconStorygameMyStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.25a.75.75 0 0 0-.75.75v6.5c0 .69.56 1.25 1.25 1.25H22a.75.75 0 0 0 .75-.75A7.75 7.75 0 0 0 15 1.25Zm.75 7V2.795a6.253 6.253 0 0 1 5.456 5.455H15.75Zm-3.75-6c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75a.75.75 0 0 0-.75-.75h-5a.75.75 0 0 0-.75.75A3.25 3.25 0 1 1 12 8.75a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75ZM3.75 12a8.25 8.25 0 0 1 7.5-8.216v3.525a4.751 4.751 0 1 0 5.441 5.441h3.525A8.251 8.251 0 0 1 3.75 12Z",
    fill: "#fff",
    fillOpacity: "current"
  })));
};
export default SvgIconStorygameMyStatus;